import { type UserLevel } from '@common/types/api/auth';

export interface ContractsResponse {
  id: number;
  contractNumber: string;
  startDate?: string;
  endDate?: string;
}

interface CurrentFirmwareState {
  normalizedFirmwareVersion: string;
  firmwareUpdatedUtc: string;
  normalizedCommunicationFirmwareVersion: string;
  communicationFirmwareUpdatedUtc: string;
  firmwareId: string;
  firmwareName: string;
  firmwareFileName: string;
  firmwareComment: string;
}

interface PendingFirmwareState {
  firmwareId?: string;
  firmwareName?: string;
  firmwareFileName?: string;
  firmwareComment?: string;
}

export interface FirmwareState {
  current: CurrentFirmwareState;
  pending: PendingFirmwareState;
}

interface FirmwareCreatedBy {
  firstName?: string;
  lastName?: string;
}

export interface AvailableFirmware {
  id: string;
  name: string;
  fileName: string;
  createdUtc: string;
  createdBy: FirmwareCreatedBy;
  comment: string;
  retailerAccessIds?: string[];
  minUserLevel?: UserLevel;
}

export enum FirmwareVersionType {
  CommunicationFirmware = 0,
  Firmware = 1,
}
